<div class="row page-header">
    <div class="col-12">
        <h1>Notifications <small>Manage and send notifications to WebApps users</small></h1>
    </div>
</div>
<div>
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" style="margin-bottom: 10px">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Notification Templates</a>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Sent Notifications</a>
        </li>
        <li [ngbNavItem]="3" [destroyOnHide]="false">
            <a ngbNavLink>Active Users</a>
        </li>
    </ul>
    <app-notification-templates [hidden]="active !== 1"></app-notification-templates>
    <app-sent-notifications [hidden]="active !== 2" [activeTab]="active"></app-sent-notifications>
    <app-notification-active-users [hidden]="active !== 3" [activeTab]="active"></app-notification-active-users>
</div>
